import { useConfig, useNotification, useOidcWithAdmin } from '@revenuewell/front-end-bundle';
import { FC, useMemo, useState } from 'react';
import { usePatientProfile } from '../../../../../../../../hooks/use-patient-profile';
import {
  ContactApi,
  PatientPreferencesRequest,
  PatientPreferencesResponse
} from '../../../../../../../../services/api-client/contact-api';
import { PatientProfileHeader } from '../../../../header/header';
import { QuickNavMenu } from '../../../../header/quick-nav-menu/quick-nav-menu';
import { usePatientProfileWidget } from '../../../../hooks/use-patient-profile-widget';
import { WidgetRoutePath } from '../../../../navigation/route-config';
import { ViewContentWrapper } from '../../../shared/view-content/view-content.styles';
import AppointmentSection from '../../shared/appointment-section/appointment-section';
import { PreferencesViewWrapper } from '../../shared/preferences-view-wrapper/preferences-view-wrapper';

export const AppointmentRemindersView: FC = (props) => {
  const { config } = useConfig();
  const { oidcService } = useOidcWithAdmin();
  const { showSuccess } = useNotification();
  const { goTo } = usePatientProfileWidget();
  const { patientPreferences, refreshPatientPreferences } = usePatientProfile();
  const [localPreferences, setLocalPreferences] = useState<PatientPreferencesResponse>(patientPreferences);
  const contactApi = useMemo(() => new ContactApi(config, oidcService), [config, oidcService]);

  const updateLocalPreferences = (state: Partial<PatientPreferencesResponse>) => {
    const newState = { ...localPreferences, ...state };
    setLocalPreferences(newState);
  };

  const updateAppointmentReminderPreferences = async () => {
    await contactApi.patchPatientPreferences(localPreferences.patientId, localPreferences as PatientPreferencesRequest);
    await refreshPatientPreferences();
    showSuccess('Appointment reminder preferences successfully saved');
    goTo(WidgetRoutePath.COMM_PREFERENCES);
  };

  return (
    <>
      <PatientProfileHeader />
      <QuickNavMenu />
      <ViewContentWrapper>
        <PreferencesViewWrapper onSave={updateAppointmentReminderPreferences}>
          <AppointmentSection
            header="Save the Date"
            preference={patientPreferences.saveDateReminderScheduleStatus}
            onChange={(value) =>
              updateLocalPreferences({
                saveDateReminderScheduleStatus: value
              })
            }
          />
          <AppointmentSection
            header="Postcard"
            preference={patientPreferences.postCardReminderScheduleStatus}
            onChange={(value) =>
              updateLocalPreferences({
                postCardReminderScheduleStatus: value
              })
            }
          />
          <AppointmentSection
            header="First Reminder"
            preference={patientPreferences.firstReminderScheduleStatus}
            onChange={(value) =>
              updateLocalPreferences({
                firstReminderScheduleStatus: value
              })
            }
          />
          <AppointmentSection
            header="Second Reminder"
            preference={patientPreferences.secondReminderScheduleStatus}
            onChange={(value) =>
              updateLocalPreferences({
                secondReminderScheduleStatus: value
              })
            }
          />
          <AppointmentSection
            header={'Same Day Reminder'}
            preference={patientPreferences.sameDayReminderScheduleStatus}
            onChange={(value) =>
              updateLocalPreferences({
                sameDayReminderScheduleStatus: value
              })
            }
          />
        </PreferencesViewWrapper>
      </ViewContentWrapper>
    </>
  );
};
